import { render } from "./ResponseQuotesTable.vue?vue&type=template&id=2fe0c69e&scoped=true"
import script from "./ResponseQuotesTable.vue?vue&type=script&lang=js"
export * from "./ResponseQuotesTable.vue?vue&type=script&lang=js"

import "./ResponseQuotesTable.vue?vue&type=style&index=0&id=2fe0c69e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2fe0c69e"]])

export default __exports__